import { AllAccountSummaryGetResponse } from 'const/syfApiQueries'
import { NotificationAccount } from '../typings/notifications'

const getAccountsForPostOfficeReturns = (
  allAccountSummaryData: AllAccountSummaryGetResponse[]
) => {
  const accounts: NotificationAccount[] = []
  allAccountSummaryData.forEach((accountData) => {
    if (accountData?.profile?.addressOnHold) {
      accounts.push({
        accountId: accountData?.accountId,
        accountName: accountData?.product?.displayName
      })
    }
  })
  return accounts
}

export default getAccountsForPostOfficeReturns
